/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { NumberFigureUnit } from './numberFigureUnit';
import type { NumberFigureValue } from './numberFigureValue';
import type { Extras } from './extras';

export interface NumberFigure {
  name: string;
  shape: 'number';
  unit: NumberFigureUnit;
  value: NumberFigureValue;
  extras: Extras;
}
